module.exports = __webpack_public_path__ + "media/images/flags/SN-67031d86c8263fe20cc5e8f21bd9183a.svg";